import { createContext } from 'react';

export { default as UsersProvider } from './UsersProvider';
export { default as RolesProvider } from './RolesProvider';
export { default as ShiftsProvider } from './ShiftsProvider';

export const UserContext = createContext({});
export const RoleContext = createContext({});
export const ShiftContext = createContext({});
